import type {
  ClusterModel,
  ContactModel,
  ProductDetailsContainerModel,
  ProductDetailsV2,
  ProductModel
} from "@/models/cluster";
import { getContact } from "@/services/contacts.service";
import type VueI18n from "vue-i18n";
import { ControlClusterModel } from "./ControlClusterModel";

export class ToolManagementModel implements ProductDetailsContainerModel {
  constructor(private $i18n: VueI18n) {}
  get details(): ProductDetailsV2 {
    return {
      teaser: {
        text: this.$i18n.tc("toolMan.details.teaser.text")
      },
      featureTeaser: this.$i18n.tc("toolMan.details.featureTeaser"),
      features: [
        {
          title: this.$i18n.tc("toolMan.details.features.transparency.title"),
          text: this.$i18n.tc("toolMan.details.features.transparency.text"),
          icon: require("@/assets/ui-assets/assets/icons/np_realtime_591026_000000.svg")
        },
        {
          title: this.$i18n.tc("toolMan.details.features.integration.title"),
          text: this.$i18n.tc("toolMan.details.features.integration.text"),
          icon: require("@/assets/ui-assets/assets/icons/np_dashboard_3048219_000000.svg")
        },
        {
          title: this.$i18n.tc("toolMan.details.features.independent.title"),
          text: this.$i18n.tc("toolMan.details.features.independent.text"),
          icon: require("@/assets/ui-assets/assets/icons/np_edit_3248033_000000.svg")
        }
      ],
      explanation: {
        title: this.$i18n.tc("toolMan.details.explanation.title"),
        text: this.$i18n.tc("toolMan.details.explanation.text"),
        image: require("@/assets/ui-assets/assets/toolmanagement.png")
      },
      contactTeaser: this.$i18n.tc("toolMan.details.contactTeaser")
    };
  }

  get cluster(): ClusterModel {
    return new ControlClusterModel(this.$i18n);
  }
  get product(): ProductModel {
    return {
      id: "toolman",
      title: this.$i18n.tc("toolMan.product.title"),
      description: this.$i18n.tc("toolMan.product.description"),
      image: require("@/assets/ui-assets/assets/design01/Toolmanagementsystem_einfarbig_RGB.svg"),
      imagehover: require("@/assets/ui-assets/assets/design01/Toolmanagementsystem_mehrfarbig_RGB.svg")
    };
  }

  get contacts(): ContactModel[] {
    return [getContact("cackermann")];
  }
}
